// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"c332d21f","453":"8ab44547","837":"52642355"}[chunkId] + ".chunk.js";
};